import { Paper } from '@ui';
import { AuthTitleSC } from '@pages/auth/auth.styled';
import styled from 'styled-components';
import { ButtonSC } from '../../../../../components/button/button.styled';

export const StepFormSC = styled(Paper)`
  position: relative;
  grid-area: form;

  ${AuthTitleSC} {
    margin-bottom: 30px;
  }

  .divider {
    opacity: 0.15;
    border-top: 0.1px solid #000;
  }

  .agreements {
    text-align: center;

    span {
      display: block;
    }

    a {
      color: #6ad5e5;
    }
  }

  .form {
    .phone-number {
      color: rgba(41, 49, 87, 0.4);
    }
  }

  ${ButtonSC} {
    box-shadow: none;
    font-weight: 800;
  }

  .ui-textfield {
    width: 100%;
  }
`;
